/** @jsxImportSource @emotion/react */

import { TypeListFunctionBtn } from "constants/list-btn-function";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ButtonFunctionStyle } from "./style.index";

const ButtonFunction = (props: TypeListFunctionBtn) => {
  const { image, link, name } = props;
  const { t } = useTranslation(["profile"]);

  return (
    <Link to={link} css={ButtonFunctionStyle.wrapper}>
      <img src={image} alt="" />
      <span>{t(name)}</span>
    </Link>
  );
};

export default ButtonFunction;
